import { Component, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-page-placeholder',
  imports: [TranslatePipe],
  templateUrl: './page-placeholder.component.html',
  styleUrl: './page-placeholder.component.scss'
})
export class PagePlaceholderComponent {
  @Input() icon = '';
  @Input() title = '';
  @Input() subtitle = '';
  @Input() badge = 'common.coming_soon';
}
